import React, { useState, useEffect, useRef, useCallback } from 'react';
import Iridescence from './Iridescence';
import ASCIIText from './ASCIIText';
import PortalTransition from './PortalTransition';
import DadBirthday from './DadBirthday';
import DuckGarden from './DuckGarden';

const SECRET_CODES = { derfff: 'birthday', natasha: 'garden' };
const SECRET_BUFFER_LENGTH = Math.max(...Object.keys(SECRET_CODES).map(code => code.length));

const Home = () => {
  const [secretMode, setSecretMode] = useState('hidden');
  const [activeSecret, setActiveSecret] = useState(null);
  const homeContentRef = useRef(null);

  // Both easter eggs are typed on the normal homepage. Neither is a password.
  useEffect(() => {
    let userInput = '';

    const onKeyDown = (event) => {
      if (secretMode !== 'hidden') return;
      if (event.repeat) return;
      const target = event.target;
      if (event.metaKey || event.ctrlKey || event.altKey ||
          target?.isContentEditable || target?.closest?.('input, textarea, select, [contenteditable]:not([contenteditable="false"])')) {
        userInput = '';
        return;
      }
      if (typeof event.key !== 'string' || event.key.length !== 1) {
        userInput = '';
        return;
      }

      userInput = (userInput + event.key.toLowerCase()).slice(-SECRET_BUFFER_LENGTH);
      for (const [code, destination] of Object.entries(SECRET_CODES)) {
        if (userInput.endsWith(code)) {
          userInput = '';
          setActiveSecret(destination);
          setSecretMode('transitioning');
          break;
        }
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [secretMode]);

  const handleTransitionComplete = useCallback(() => {
    setSecretMode(mode => mode === 'transitioning' ? 'revealed' : mode);
  }, []);

  const handleBack = useCallback(() => {
    setSecretMode('exiting');
  }, []);

  const handleExitComplete = useCallback(() => {
    setSecretMode('hidden');
    setActiveSecret(null);
  }, []);

  const gardenIsOpen = activeSecret === 'garden' && secretMode !== 'hidden';
  const showHome = secretMode === 'hidden' || secretMode === 'exiting' ||
    (activeSecret === 'birthday' && secretMode === 'transitioning');

  return (
    <div>
      {/* Normal home content */}
      {showHome && (
        <div ref={homeContentRef}>
          <Iridescence />
          <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <ASCIIText text='thealexwang' />
            <div style={{
              position: 'absolute',
              bottom: '8%',
              width: '100%',
              height: '45vh',
            }}>
              <ASCIIText text='aiatrogo' asciiFontSize={6} textFontSize={230} planeBaseHeight={4.5} />
            </div>
          </div>
        </div>
      )}

      {/* Portal transition overlay */}
      {activeSecret === 'birthday' && (secretMode === 'transitioning' || secretMode === 'exiting') && (
        <PortalTransition
          isActive={true}
          isReversing={secretMode === 'exiting'}
          onComplete={secretMode === 'transitioning' ? handleTransitionComplete : handleExitComplete}
          homeContentRef={homeContentRef}
        />
      )}

      {/* Birthday page */}
      {secretMode === 'revealed' && activeSecret === 'birthday' && (
        <DadBirthday onBack={handleBack} />
      )}

      {gardenIsOpen && (
        <DuckGarden
          onBack={handleBack}
          onReady={handleTransitionComplete}
          onExited={handleExitComplete}
          exiting={secretMode === 'exiting'}
        />
      )}
    </div>
  );
};

export default Home;
